import format from 'date-fns/format';

const TIME_ZONE = 'Z';

export const getHistoryChangeDate = (date: string): string =>
  format(new Date(date.includes(TIME_ZONE) ? date : date + TIME_ZONE), 'd MMM, y, p');
